// app/layout/Root.tsx
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/store";

const Root = observer(() => {
  const { userStore } = useStore();

  useEffect(() => {
    userStore.loadUser();
  }, [userStore]);

  return <Outlet />;
});

export default Root;
